import { gql } from "@apollo/client";

export default gql`
  mutation ToggleProductStack($governmentId: ObjectId, $productId: ObjectId) {
    toggleProductStack(governmentId: $governmentId, productId: $productId) {
      _id
      inViewerStack
      governmentsUsingCount
    }
  }
`;
